<div id="range-chart-tooltip">
  <p>
    {{ 'sp.revamp.assetGraph.tooltipText.expected' | translate }}
    {{ tooltipData.expected | translateNumber: language:currency }}
  </p>
  <p>
    {{ 'sp.revamp.assetGraph.tooltipText.potentialReturn' | translate }}
    {{ tooltipData.potential | translateNumber: language:currency }}
  </p>
  <p>
    {{ 'sp.revamp.assetGraph.tooltipText.loss' | translate }}
    {{ tooltipData.loss | translateNumber: language:currency }}
  </p>
  <div *ngIf="kind === '3a'" class="icon-i-info" (click)="onToggleDetails()"></div>
</div>
